import { ILoginState } from '../interfaces/login-state.interface';
import { LoginService } from '../services/login.service';
import * as loginActions from '../actions/login.actions';
import * as personnelActions from '../actions/personnel.actions';

export const emptyState: ILoginState = {
  isLoggedIn: false,
  error: undefined,
  redirectUrl: undefined,
  currentUser: undefined,
  personnelId: undefined,
  firstName: undefined,
  lastName: undefined,
  status: undefined,
};

export const getInitialState = (): ILoginState => {
  const storedToken = localStorage.getItem(LoginService.ACCESS_TOKEN_NAME);
  let accessToken: Record<string, unknown> | null = null;

  if (storedToken) {
    try {
      accessToken = JSON.parse(storedToken);
    } catch {
      accessToken = null;
    }
  }

  return Object.assign(
    {},
    emptyState,
    {
      isLoggedIn: accessToken !== null,
    },
    accessToken !== null
      ? {
          currentUser: accessToken.currentUser,
          personnelId: accessToken.personnelId,
          firstName: accessToken.firstName,
          lastName: accessToken.lastName,
          isSupervisor: accessToken.isSupervisor,
          status: accessToken.status,
        }
      : {},
  );
};

export function reducer(state: ILoginState = getInitialState(), action: any): ILoginState {
  switch (action.type) {
    case loginActions.LOGIN_SUCCESS:
    case loginActions.REFRESH_TOKEN_SUCCESS:
      return Object.assign({}, state, {
        isLoggedIn: true,
        error: undefined,
        currentUser: action.payload.currentUser,
        firstName: action.payload.FirstName,
        lastName: action.payload.LastName,
        personnelId: action.payload.PersonnelId,
        isSupervisor: action.payload.IsSupervisor,
        status: action.payload.Status,
      });

    case loginActions.LOGIN_FAILED:
      return Object.assign({}, state, {
        isLoggedIn: false,
        error: action.payload.message,
        currentUser: undefined,
      });

    case loginActions.SET_REDIRECT_URL:
      return Object.assign({}, state, { redirectUrl: action.payload });

    case loginActions.LOGOUT:
    case loginActions.EXPIRE_LOGIN:
      return Object.assign({}, state, emptyState);

    case personnelActions.SET_PERSONNEL_STATUS_ON_CLIENT: {
      return Object.assign({}, state, { status: action.payload.status });
    }
    default:
      return state;
  }
}
